export const IS_SERVER = typeof window === "undefined";

export const BUILD_VERSION = process.env.NEXT_PUBLIC_BUILD_VERSION;

export const JOIN_WAITLIST_URL = "https://tally.so/r/mVkaEl";

export const GTM_ID = process.env.GTM_ID;

export const DISCORD_INVITE_URL = "https://discord.com/invite/CahCmBCDgE";
